import React, { FC } from 'react'
import { ContentfulRichText } from '@/atoms/ContentfulRichText'
import { FlexColumn } from '@/atoms/FlexContainers'
import { TitleMD } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { useGiveawayContext } from '../../context/GiveawayContext'
import { giveawayRulesRichTextOverrides } from '../../utils/richtextUtils'

interface GiveawayRulesSectionProps {
  className?: string
}

export const GiveawayRulesSection: FC<GiveawayRulesSectionProps> = ({ className }) => {
  const { t } = useTranslate('tickets')
  const {
    content: { rules },
  } = useGiveawayContext()

  if (!rules) {
    return null
  }

  return (
    <FlexColumn className={className}>
      <TitleMD weight="medium" color="white">
        {t('giveawayRules', 'Giveaway Rules')}
      </TitleMD>

      <ContentfulRichText {...rules} renderOptionOverrides={giveawayRulesRichTextOverrides} />
    </FlexColumn>
  )
}
